import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';
import { VbUiToggleContentDisplayAngularModule } from 'rev-shared/ui/toggleContentDisplay/VbUiTogleContentDisplay.AngularModule';

import { InThisVideoComponent } from './InThisVideo.Component';
import { InThisVideoEntryAngularComponent } from './InThisVideoEntryAngular.Component';

const components = [
	InThisVideoComponent,
	InThisVideoEntryAngularComponent
];
@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		TranslateModule,
		VbProfilePictureModule,
		VbUiToggleContentDisplayAngularModule
	]
})
export class InThisVideoAngularModule { }
